angular.module('app.directives').directive('appPagination', function($location) {
    const button = (label, rel) => `<div ng-click="page(pagination.${rel})"
        ng-class="{ disabled: pagination.${rel} === undefined }"
        class="btn btn-default">${label}</div>`;
    return {
        restrict: 'E',
        template: button('First', 'first') +
            button('&laquo; Previous', 'previous') +
            button('Next &raquo;', 'next') +
            button('Last', 'last') +
            ' &nbsp;&nbsp; Total Results: {{pagination.total | number}}'
    };
});


// WEBPACK FOOTER //
// ./directives/pagination.js